import { TextArea } from '@heroui/react';
import { MarkdownPreview } from '@/lib/markdown';

interface MarkdownTextareaProps {
  value: string;
  onChange: (value: string) => void;
  /** Коммит значения — например, мгновенное сохранение в БД (у карточек задач) */
  onBlur?: () => void;
  label?: string;
  placeholder?: string;
  minHeight?: number;
  readOnly?: boolean;
}

/**
 * Markdown-поле как исходник: правка — обычной textarea (без WYSIWYG;
 * формат подсвечивается только в мобильном превью/на мобиле), просмотр —
 * MarkdownPreview простым текстом без рамки. Для полей, где WYSIWYG
 * не нужен: описание, follow-up, ИИ-контекст — Crepe-редактор только
 * у инструкции.
 */
export function MarkdownTextarea({
  value,
  onChange,
  onBlur,
  label,
  placeholder = '',
  minHeight = 72,
  readOnly = false,
}: MarkdownTextareaProps) {
  return (
    <div className="flex w-full flex-col gap-1.5">
      {label && <span className="text-sm font-medium text-foreground">{label}</span>}
      {readOnly ? (
        <div className="text-sm text-foreground">
          {value.trim() ? (
            <MarkdownPreview source={value} />
          ) : (
            <span className="text-field-placeholder">—</span>
          )}
        </div>
      ) : (
        <TextArea
          variant="secondary"
          aria-label={label}
          className="resize-y"
          style={{ minHeight }}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
          placeholder={placeholder}
        />
      )}
    </div>
  );
}
